import { Link } from "react-router-dom";
import { Cross } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-brand-line bg-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-full bg-gradient-to-br from-brand-sky to-brand-sage grid place-items-center text-white">
              <Cross className="w-4 h-4" strokeWidth={1.8} />
            </span>
            <span className="font-serif text-xl text-brand-ink">Path to Repentance</span>
          </div>
          <p className="text-sm text-brand-quiet leading-relaxed max-w-xs">
            A private, prayerful place to confess, reflect, and grow nearer to Christ — one honest day at a time.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-brand-ink mb-3">Walk with us</h4>
          <ul className="space-y-2 text-sm text-brand-quiet">
            <li><Link to="/about" className="hover:text-brand-ink">About Christianity</Link></li>
            <li><Link to="/bible" className="hover:text-brand-ink">Bible Teachings</Link></li>
            <li><Link to="/contact" className="hover:text-brand-ink">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-medium text-brand-ink mb-3">Your journey</h4>
          <ul className="space-y-2 text-sm text-brand-quiet">
            <li><Link to="/dashboard" className="hover:text-brand-ink">Dashboard</Link></li>
            <li><Link to="/chat" className="hover:text-brand-ink">AI Companion</Link></li>
            <li><Link to="/prayer" className="hover:text-brand-ink">Prayer Journal</Link></li>
            <li><Link to="/privacy" className="hover:text-brand-ink">Data Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-brand-ink">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-medium text-brand-ink mb-3">A verse to carry</h4>
          <p className="scripture-quote text-base text-brand-quiet leading-relaxed">
            “Come to Me, all you who labor and are heavy laden, and I will give you rest.”
          </p>
          <p className="text-xs text-brand-muted mt-2">— Matthew 11:28</p>
        </div>
      </div>
      <div className="border-t border-brand-line">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 text-xs text-brand-muted flex flex-col md:flex-row items-center justify-between gap-2">
          <p>© {new Date().getFullYear()} Path to Repentance · Your records are private.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-brand-ink">Privacy</Link>
            <Link to="/terms" className="hover:text-brand-ink">Terms</Link>
            <p className="scripture-quote">Soli Deo gloria</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
